import axios from 'axios'

axios.defaults.headers = {
  'Content-Type': 'application/json'
}

export default {

  fetchRecallCollection (startDate, endDate, searchString) {
    return axios.get('https://www.saferproducts.gov/RestWebServices/Recall', {
      params: {
        RecallDateStart: startDate,
        RecallDateEnd: endDate,
        RecallDescription: searchString,
        format: 'json'
      }
    })
      .then(response => {
        return response.data
      })
  },

  fetchSingleRecall (id) {
    return axios.get('https://www.saferproducts.gov/RestWebServices/Recall', {
      params: {
        RecallID: id,
        format: 'json'
      }
    })
      .then(response => {
        return response.data[0]
      })
  }
}
